import Vue from 'vue'
import Router from 'vue-router'
import ProjectsList from '@/components/Projects/List/List'
import ProjectForm from '@/components/Projects/Form/Form'
import PartnersList from '@/components/Partners/List'
import ProvidersList from '@/components/Providers/List'
import ProviderForm from '@/components/Providers/Form'
import PaymentMethodsList from '@/components/PaymentMethods/List'
import PaymentMethodsForm from '@/components/PaymentMethods/Form'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/projects', alias: '/', component: ProjectsList },
    { path: '/projects/new', component: ProjectForm, props: true },
    { path: '/projects/:id/edit', component: ProjectForm, props: true },
    { path: '/partners', component: PartnersList },
    { path: '/providers', component: ProvidersList },
    { path: '/providers/new', component: ProviderForm, props: true },
    { path: '/providers/:id/edit', component: ProviderForm, props: true },
    { path: '/payment_methods', component: PaymentMethodsList },
    { path: '/payment_methods/new', component: PaymentMethodsForm, prop: true },
    {
      path: '/payment_methods/:id/edit',
      component: PaymentMethodsForm,
      props: true,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router.js